export const CREATE_BANK_RECEIPT  = 'CREATE_BANK_RECEIPT';
export const GET_BANK_RECEIPTS  = 'GET_BANK_RECEIPTS';
export const BANK_RECEIPT_REQUEST  = 'BANK_RECEIPT_REQUEST';
export const DELETE_BANK_RECEIPT  = 'DELETE_BANK_RECEIPT';
export const UPDATE_BANK_RECEIPT  = 'UPDATE_BANK_RECEIPT';
export const BANK_RECEIPT_REQUEST_SUCCESS  = 'BANK_RECEIPT_REQUEST_SUCCESS';
export const BANK_RECEIPT_REQUEST_FAILURE  = 'BANK_RECEIPT_REQUEST_FAILURE';
export const GET_BANK_RECEIPTS_PAGE  = 'GET_BANK_RECEIPTS_PAGE';